import { Link, Tooltip } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { JupiterTheme } from '../theme/types';

interface Props {
  url: string;
  displayText?: string;
}

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    link: {
      color: theme.palette.primary.main,
    },
  })
);

const SafeURL = ({ displayText, url }: Props) => {
  const classes = useStyles();
  const display = displayText ? displayText : url;
  return isSafeUrl(url) ? (
    <Tooltip title={url} enterDelay={500}>
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        {display}
      </Link>
    </Tooltip>
  ) : (
    <div>{display}</div>
  );
};

function isSafeUrl(url: string): boolean {
  const whitelist = ['http:', 'https:'];
  let safe = false;
  whitelist.forEach((protocol: string) => {
    if (url.indexOf(protocol) === 0) {
      safe = true;
    }
  });
  return safe;
}

export default SafeURL;
